/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { IApresentarDimensaoModel, IApresentarDimensaoPerguntaModel, IWizardModel } from '../helpers/ResponderPesquisaHelper'
import { ErrorMessage, Field, FormikProps } from 'formik'
import { EnumPesquisaParticipanteStatus, EnumPesquisaStatus, EnumPesquisaTipoDisposicaoPergunta, RequestMethod } from '../../../../modules/services/core/_enums'
import { useHttpClient } from '../../../../modules/services/Bundle'

type Props = {
  formik: FormikProps<IWizardModel>,
  perguntas: IApresentarDimensaoPerguntaModel[] | undefined,
  dimensaoIndex?: number
}

const PesquisaPerguntas: React.FC<Props> = ({ formik, perguntas, dimensaoIndex }) => {

  const httpClient = useHttpClient()

  const escala: any[] = [];
  if (formik.values.EscalaPesquisa) {
    for (let i = formik.values.EscalaPesquisa.Inicio; i <= formik.values.EscalaPesquisa.Fim; i++) {
      escala.push(
        <span key={i} className="escala-label">{i}</span>
      );
    }
  }

  return (
    <>
      {perguntas && perguntas.map((pergunta, perguntaIndex) => {
        const perguntaAtual = dimensaoIndex ? formik.values.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex] : formik.values.Perguntas[perguntaIndex];
        const onClickInputRangeResposta = async (e: React.TouchEvent<HTMLInputElement> | React.MouseEvent<HTMLInputElement>, idPergunta: number) => {

          let resposta: number | undefined = parseInt(e.currentTarget.value)

          const response = await httpClient.request({
            method: RequestMethod.GET,
            endpoint: '/Pesquisa/ResponderPesquisa/ResponderPergunta',
            queryObject: {
              chave: formik.values.Participante.Chave,
              resposta: resposta,
              idDimensaoPergunta: idPergunta
            },
            blockFree: true
          })

          let newValues = { ...formik.values }

          if (response.success && response.payload) {

            const dimensao: IApresentarDimensaoModel = response.payload

            const index = newValues.Dimensoes.findIndex(d => d.Id == dimensao.Id)

            newValues.Dimensoes[index].QtdPerguntas = dimensao.QtdPerguntas
            newValues.Dimensoes[index].QtdPerguntasRespondidas = dimensao.QtdPerguntasRespondidas
            newValues.Dimensoes[index].Porcentagem = dimensao.Porcentagem
            newValues.Dimensoes[index].TodasPerguntasRespondidas = dimensao.TodasPerguntasRespondidas

          }
          else resposta = undefined

          if (dimensaoIndex !== undefined) newValues.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].Resposta = resposta
          else newValues.Perguntas[perguntaIndex].Resposta = resposta

          formik.setValues(newValues)

        }

        const onClickInputRangeRespostaAB = async (e: React.TouchEvent<HTMLInputElement> | React.MouseEvent<HTMLInputElement>, idPergunta: number) => {

          let resposta: number | undefined = parseInt(e.currentTarget.value)

          let newValues = { ...formik.values }

          let eRespA = e.currentTarget.classList.contains('RespA')

          let respAntes = dimensaoIndex != undefined ? newValues.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].Resposta : newValues.Perguntas[perguntaIndex].Resposta;
          let respBAntes = dimensaoIndex != undefined ? newValues.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].RespostaB : newValues.Perguntas[perguntaIndex].RespostaB;

          if (dimensaoIndex !== undefined) {
            newValues.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].Resposta = eRespA ? resposta : Math.abs(resposta - 7);
            newValues.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].RespostaB = eRespA ? Math.abs(resposta - 7) : resposta
          }
          else {
            newValues.Perguntas[perguntaIndex].Resposta = eRespA ? resposta : Math.abs(resposta - 7);
            newValues.Perguntas[perguntaIndex].RespostaB = eRespA ? Math.abs(resposta - 7) : resposta
          }
          formik.setValues(newValues)
          formik.validateForm()

          const response = await httpClient.request({
            method: RequestMethod.GET,
            endpoint: '/Pesquisa/ResponderPesquisa/ResponderPergunta',
            queryObject: {
              chave: formik.values.Participante.Chave,
              resposta: eRespA ? resposta : Math.abs(resposta - 7),
              respostaB: eRespA ? Math.abs(resposta - 7) : resposta,
              idDimensaoPergunta: idPergunta
            },
            blockFree: true
          })

          if (response.success && response.payload) {

            const dimensao: IApresentarDimensaoModel = response.payload

            const index = newValues.Dimensoes.findIndex(d => d.Id == dimensao.Id)

            newValues.Dimensoes[index].QtdPerguntas = dimensao.QtdPerguntas
            newValues.Dimensoes[index].QtdPerguntasRespondidas = dimensao.QtdPerguntasRespondidas
            newValues.Dimensoes[index].Porcentagem = dimensao.Porcentagem
            newValues.Dimensoes[index].TodasPerguntasRespondidas = dimensao.TodasPerguntasRespondidas

          }
          else {
            if (dimensaoIndex !== undefined) {
              newValues.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].Resposta = respAntes;
              newValues.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].RespostaB = respBAntes;
            }
            else {
              newValues.Perguntas[perguntaIndex].Resposta = respAntes
              newValues.Perguntas[perguntaIndex].RespostaB = respBAntes
            }
            formik.setValues(newValues)
          }

        }

        return (
          <div
            key={perguntaIndex}
            className={`w-100 p-5 border border-secondary rounded ${perguntaIndex < (perguntas.length - 1) ? 'mb-5' : ''}`}
          >
            <textarea
              className={`form-control form-control-lg form-control-solid bg-light-success textarea-pergunta-pesquisa mb-5`}
              value={pergunta.Texto}
              disabled={true}
            />
            {pergunta.QuestaoPergunta == null || pergunta.QuestaoPergunta.length == 0 ? (
              <>
                <div className='escala-container'>
                  {escala}
                </div>
                {dimensaoIndex !== undefined ? (
                  <>
                    <input
                      type="range"
                      min={formik.values.EscalaPesquisa ? formik.values.EscalaPesquisa.Inicio : 0}
                      max={formik.values.EscalaPesquisa ? formik.values.EscalaPesquisa.Fim : 10}
                      step="1"
                      name={`Dimensoes.${dimensaoIndex}.Perguntas.${perguntaIndex}.Resposta`}
                      className={`pesquisa-input-range ${formik.values.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].Resposta !== null && formik.values.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].Resposta !== undefined ? 'pesquisa-input-range-com-resposta' : 'pesquisa-input-range-sem-resposta'} form-range w-100`}
                      list={`input-range-pergunta-${pergunta.Id}`}
                      value={formik.values.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].Resposta ?? (formik.values.EscalaPesquisa ? formik.values.EscalaPesquisa.Inicio : 0)}
                      disabled={formik.values.Pesquisa.Status !== EnumPesquisaStatus.EmAndamento || formik.values.Participante.Status !== EnumPesquisaParticipanteStatus['Em andamento']}
                      onChange={(e) => {
                        const valor = Number(e.target.value)
                        formik.setFieldValue(`Dimensoes.${dimensaoIndex}.Perguntas.${perguntaIndex}.Resposta`, valor)
                      }}
                      onBlur={() => {
                        formik.setFieldTouched(`Dimensoes.${dimensaoIndex}.Perguntas.${perguntaIndex}.Resposta`, true)
                      }}
                      onMouseUp={(e: React.MouseEvent<HTMLInputElement>) => onClickInputRangeResposta(e, pergunta.Id)}
                      onTouchEnd={(e: React.TouchEvent<HTMLInputElement>) => onClickInputRangeResposta(e, pergunta.Id)}
                    />
                  </>
                ) : (
                  <>
                    <input
                      type="range"
                      min={formik.values.EscalaPesquisa ? formik.values.EscalaPesquisa.Inicio : 0}
                      max={formik.values.EscalaPesquisa ? formik.values.EscalaPesquisa.Fim : 10}
                      step="1"
                      name={`Perguntas.${perguntaIndex}.Resposta`}
                      className={`pesquisa-input-range ${formik.values.Perguntas[perguntaIndex].Resposta !== null && formik.values.Perguntas[perguntaIndex].Resposta !== undefined ? 'pesquisa-input-range-com-resposta' : 'pesquisa-input-range-sem-resposta'} form-range w-100`}
                      list={`input-range-pergunta-${pergunta.Id}`}
                      value={formik.values.Perguntas[perguntaIndex].Resposta ?? (formik.values.EscalaPesquisa ? formik.values.EscalaPesquisa.Inicio : 0)}
                      disabled={formik.values.Pesquisa.Status !== EnumPesquisaStatus.EmAndamento || formik.values.Participante.Status !== EnumPesquisaParticipanteStatus['Em andamento']}
                      onChange={(e) => {
                        const valor = Number(e.target.value)
                        formik.setFieldValue(`Perguntas.${perguntaIndex}.Resposta`, valor)
                      }}
                      onBlur={() => {
                        formik.setFieldTouched(`Perguntas.${perguntaIndex}.Resposta`, true)
                      }}
                      onMouseUp={(e: React.MouseEvent<HTMLInputElement>) => onClickInputRangeResposta(e, pergunta.Id)}
                      onTouchEnd={(e: React.TouchEvent<HTMLInputElement>) => onClickInputRangeResposta(e, pergunta.Id)}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                {pergunta.QuestaoPergunta.map((questao, qIndex) => {
                  return (
                    <div key={`div-range-pergunta-${pergunta.Id}-questao-${questao.Id}`} className='ms-5'>
                      <textarea
                        className={`form-control form-control-lg form-control-solid bg-light-secondary textarea-pergunta-pesquisa mb-5`}
                        value={`${qIndex == 0 ? "A" : "B"}) ${questao.ValorQuestao ?? ''}`}
                        disabled={true}
                      />
                      <div className='escala-container'>
                        <span key="0" className="escala-label">0</span>
                        <span key="1" className="escala-label">1</span>
                        <span key="2" className="escala-label">2</span>
                        <span key="3" className="escala-label">3</span>
                        <span key="4" className="escala-label">4</span>
                        <span key="5" className="escala-label">5</span>
                        <span key="6" className="escala-label">6</span>
                        <span key="7" className="escala-label">7</span>
                      </div>
                      {dimensaoIndex !== undefined ? (
                        <>
                          <input
                            type="range"
                            min="0"
                            max="7"
                            step="1"
                            name={`Dimensoes.${dimensaoIndex}.Perguntas.${perguntaIndex}.Resposta${qIndex > 0 ? "B" : ""}`}
                            className={`pesquisa-input-range ${qIndex == 0 ? (perguntaAtual.Resposta !== null && perguntaAtual.Resposta !== undefined ? 'pesquisa-input-range-com-resposta RespA' : 'pesquisa-input-range-sem-resposta RespA') : (perguntaAtual.RespostaB !== null && perguntaAtual.RespostaB !== undefined ? 'pesquisa-input-range-com-resposta RespB' : 'pesquisa-input-range-sem-resposta RespB')} form-range w-100`}
                            list={`input-range-pergunta-${pergunta.Id}`}
                            value={
                              qIndex == 0
                                ? formik.values.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].Resposta ?? 0
                                : formik.values.Dimensoes[dimensaoIndex].Perguntas[perguntaIndex].RespostaB ?? 0
                            }
                            disabled={formik.values.Pesquisa.Status !== EnumPesquisaStatus.EmAndamento || formik.values.Participante.Status !== EnumPesquisaParticipanteStatus['Em andamento']}
                            onChange={(e) => {
                              const valor = Number(e.target.value)
                              formik.setFieldValue(`Dimensoes.${dimensaoIndex}.Perguntas.${perguntaIndex}.Resposta${qIndex > 0 ? "B" : ""}`, valor)
                            }}
                            onBlur={() => {
                              formik.setFieldTouched(`Dimensoes.${dimensaoIndex}.Perguntas.${perguntaIndex}.Resposta${qIndex > 0 ? "B" : ""}`, true)
                            }}
                            onMouseUp={(e: React.MouseEvent<HTMLInputElement>) => onClickInputRangeRespostaAB(e, pergunta.Id)}
                            onTouchEnd={(e: React.TouchEvent<HTMLInputElement>) => onClickInputRangeRespostaAB(e, pergunta.Id)}
                          />
                        </>
                      ) : (
                        <>
                          <input
                            type="range"
                            min="0"
                            max="7"
                            step="1"
                            name={`Perguntas.${perguntaIndex}.Resposta${qIndex > 0 ? "B" : ""}`}
                            className={`pesquisa-input-range ${qIndex == 0 ? (perguntaAtual.Resposta !== null && perguntaAtual.Resposta !== undefined ? 'pesquisa-input-range-com-resposta RespA' : 'pesquisa-input-range-sem-resposta RespA') : (perguntaAtual.RespostaB !== null && perguntaAtual.RespostaB !== undefined ? 'pesquisa-input-range-com-resposta RespB' : 'pesquisa-input-range-sem-resposta RespB')} form-range w-100`}
                            list={`input-range-pergunta-${pergunta.Id}`}
                            value={
                              qIndex == 0
                                ? formik.values.Perguntas[perguntaIndex].Resposta ?? 0
                                : formik.values.Perguntas[perguntaIndex].RespostaB ?? 0
                            }
                            disabled={formik.values.Pesquisa.Status !== EnumPesquisaStatus.EmAndamento || formik.values.Participante.Status !== EnumPesquisaParticipanteStatus['Em andamento']}
                            onChange={(e) => {
                              const valor = Number(e.target.value)
                              formik.setFieldValue(`Perguntas.${perguntaIndex}.Resposta${qIndex > 0 ? "B" : ""}`, valor)
                            }}
                            onBlur={() => {
                              formik.setFieldTouched(`Perguntas.${perguntaIndex}.Resposta${qIndex > 0 ? "B" : ""}`, true)
                            }}
                            onMouseUp={(e: React.MouseEvent<HTMLInputElement>) => onClickInputRangeRespostaAB(e, pergunta.Id)}
                            onTouchEnd={(e: React.TouchEvent<HTMLInputElement>) => onClickInputRangeRespostaAB(e, pergunta.Id)}
                          />
                        </>
                      )}
                    </div>
                  )
                })}
              </>
            )}
          </div>
        )
      })
      }
    </>
  )
}

export { PesquisaPerguntas }
